export const initialState = {
  loading: false,
  selectedTab: 0,
  alertDialog: false,
  alertDialogFees: false,
  alertDialogLogistics: false,
  alertText: '',
  apiSuccessResponseOOS: {
    update: null,
    hardwareFeeUpdate: null,
    hardwareLogisticsUpdate: null,
    consumableFees: null,
  },
  defaultBillSetId: 1,
  oosCountriesData: [],
  oosCountryId: 0,
  //Labor Fees
  laborFeesData: [],
  laborFeesDataCount: 0,
  isLaborFeesDataFound: false,
  //Hardware Fees
  hardwareFeesData: [],
  hardwareFeesDataCount: 0,
  isHardwareFeesDataFound: false,
  //Hardware Fees Grid Slected Row Data
  hardwareFeesSelectedData: [],
  //Hardware Logistics
  hardwareLogisticsData: [],
  hardwareLogisticsDataCount: 0,
  isHardwareLogisticsDataFound: false,
  //Hardware Logistics Grid Slected Row Data
  hardwareLogisticsSelectedData: [],
  //Non Archived States - BEGIN
  oosCountryIdNA: 0,
  //Labor Fees
  laborFeesDataNA: [],
  laborFeesDataCountNA: 0,
  isLaborFeesDataFoundNA: false,
  //Update Msgs
  updateHwFeesNonStFeesMsg: '',
  updateHwLgNonStFeesMsg: '',
  updateHwLgNonStComableFeesMsg: '', 

  //originalGrid Data
  hwFeesData: [],
  hwLogisticsData: [], 
  //Grid Data after on Change
  feesGridData: [],
  logisticsGridData: [],
  //Updated Records to be saved
  updatedFeesRecords: [],
  updatedFeesRecordsCount: 0,
  updatedLogisticsRecords: [],
  updatedLogisticsRecordsCount: 0,
  hwLogisticsNSConsumableFees: '',
  isEditedNSConsumableFee: false,
  //Non Archived States - END
  isSavedFeesFlag: false,
  isSavedLogisticsFlag: false,
  isSavedConsumableFeesFlag: false,
  reloadHWFee: null,
  reloadHwLogistics: null,
  HWFeeLoader: false,
  HwLogisticsSLoader: false,
};
